module.exports = __webpack_public_path__ + "img/category_movies__and__series.8c34ce4.png";